import { FormStyleContext } from "@common/contexts/FormStyle";
import Button from "@common/controls/Button/component";
import Select, { type OptionItem } from "@common/controls/Inputs/Select/component";
import { useI18n } from "@common/hooks/i18n";
import React from "react";

export interface PreviousNextPagerProps {
  pageNumber: number;
  pageSize: number;
  pageSizes?: number[];
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  onPageSizeChange?: (pageSize: number) => void;
}
export const PreviousNextPager = (props: PreviousNextPagerProps) => {
  const i18n = useI18n();

  const sizeOptions = React.useMemo(
    () => (props.pageSizes ?? [5, 10, 25, 50, 100]).map<OptionItem<number>>((x) => ({ label: x.toString(), value: x })),
    [props.pageSizes]
  );
  const { fieldStyle, secondaryButtonStyle } = React.useContext(FormStyleContext);

  return (
    <div className="pagination_container">
      <div className="pagination">
        <Button
          isDisabled={!props.onPreviousClick}
          onClick={props.onPreviousClick ? (e) => props.onPreviousClick!() : undefined}
          style={secondaryButtonStyle}
          type="white"
        >
          {i18n.back}
        </Button>
        <Button
          isDisabled={!props.onNextClick}
          onClick={props.onNextClick ? (e) => props.onNextClick!() : undefined}
          type="white"
          style={secondaryButtonStyle}
        >
          {i18n.next}
        </Button>
      </div>

      <div>
        {i18n.page} {props.pageNumber}
      </div>

      {!!props.onPageSizeChange && (
        <div className="page-size-selector">
          <span>{i18n.itemsPerPage}</span>
          <Select
            className="page-size"
            height="auto"
            isRequired
            name="pageSize"
            onChange={props.onPageSizeChange as any}
            options={sizeOptions}
            style={fieldStyle}
            value={props.pageSize}
          />
        </div>
      )}
    </div>
  );
};
